import { brandings } from './brandings';

export const initBranding = brandings.RIA;


// WEBPACK FOOTER //
// ./src/environment/branding/init-branding.ts